import { Cliente } from "./Cliente";
import { ConfiguracionIATA } from "./configuracionIATA";

export class ClienteConfiguracionIATA {
    clienteSolicitante: Cliente;
    configuracion: ConfiguracionIATA[];
}